/**
 * MELP Mail Spacing System
 * Based on 8px grid system (Google Material Design)
 */

export const spacing = 8;

/**
 * Spacing scale
 * Usage: spacing(1) = 8px, spacing(2) = 16px, etc.
 */
export const spacingScale = {
  0: 0,
  0.5: 4,
  1: 8,
  1.5: 12,
  2: 16,
  2.5: 20,
  3: 24,
  4: 32,
  5: 40,
  6: 48,
  7: 56,
  8: 64,
  9: 72,
  10: 80,
  12: 96,
  16: 128,
  20: 160,
  24: 192,
} as const;

export type SpacingScale = typeof spacingScale;
